/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ProviderAccreditationAliases {
  CARD_ACCREDITATION = 'card-accreditation',
  CHECKBOX_TERM = 'checkbox-term',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  CONTEXTUAL_BAR_ACCREDITATION = 'contextual-bar-accreditation',
  DECK_PROVIDER_ACCREDITATION = 'deck-provider-accreditation',
  FETCH = 'fetch',
  FETCH_0 = 'fetch-0',
  FETCH_ACCREDITATION = 'fetch-accreditation',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_CHECKBOX_TERM = 'field-checkbox-term',
  FIELD_PROVIDER = 'field-provider',
  FIELD_TYPE_ACCREDITATION = 'field-type-accreditation',
  FORM_TERM = 'form-term',
  HPMS_CUSTOM_CARD_PROVIDER_ACCREDITATION = 'hpms-custom-card-provider-accreditation',
  HPMS_TEXT_HTML_TERM = 'hpms-text-html-term',
  IMAGE_0 = 'image-0',
  LAYOUT_PROVIDER_ACCREDITATION = 'layout-provider-accreditation',
  LINK_GUIDANCE_MANUAL = 'link-guidance-manual',
  MAPPER_0 = 'mapper-0',
  MODAL_TERM = 'modal-term',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_2 = 'panel-2',
  PANEL_3 = 'panel-3',
  PANEL_ACCREDITATION = 'panel-accreditation',
  PANEL_IMAGE = 'panel-image',
  PANEL_LEFT = 'panel-left',
  PANEL_LINK_GUINDACE_MANUAL = 'panel-link-guindace-manual',
  PANEL_PROVIDER_ACCREDITATION_LIST = 'panel-provider-accreditation-list',
  PANEL_RIGHT = 'panel-right',
  PANEL_TERM = 'panel-term',
  PANEL_TRAIL = 'panel-trail',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TOAST_NOTIFICATION = 'toast-notification',
  TRAIL_ACCREDITATION = 'trail-accreditation',
}
export { ProviderAccreditationAliases };
